import React from "react";

interface SpinnerProps {
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ className }) => {
  return (
    <div
      className={`animate-spin rounded-full border-4 border-gray-300 border-t-[#EB2E67] ${className}`}
    ></div>
  );
};

export default Spinner;
